<div class="searchFor">
  <div class="content-input" *ngIf="!this.nearSearchArray.length">
    <input
      id="typeahead-http"
      type="text"
      class="input-text"
      [(ngModel)]="modelDetail"
      [ngbTypeahead]="searchLocation"
      [resultTemplate]="rt"
      [inputFormatter]="formatter"
      (selectItem)="getDetail($event)"
      placeholder="Pesquisar" />
  </div>
</div>

<h4 class="title-drop" *ngIf="searchType.fromLocationSearch && nearSearchArray.length"><span class="fa fa-map-marker"></span>{{locationsTitle}}</h4>
<div class="type-location" *ngIf="searchType.fromLocationSearch && nearSearchArray.length">
  <div class="type-location-item" *ngFor="let near of nearSearchArray">
    <p>{{near}}</p>
    <button (click)="removeLocation()" type="button">X</button>
  </div>
</div>

<div class="content-dropdown">
  <ng-template #rt let-r="result" let-t="term">
    {{ r.text}}
  </ng-template>
</div>
